import { render, staticRenderFns } from "./hotelsBookings.vue?vue&type=template&id=45b7e2ec"
import script from "./hotelsBookings.vue?vue&type=script&lang=js"
export * from "./hotelsBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports